export enum ZendraLocalizationServices {
    Controlling = 'Controlling',
    General = 'General',
    Geographic = 'Geographic',    
    Inventory = 'Inventory',
    LanguageService = 'LanguageService',
    Operational = 'Operational',
    Orchestrator = 'Orchestrator',
    Planning = 'Planning',
    WoodSecurity = 'WoodSecurity',
    WoodSupply = 'WoodSupply',
}
